import { ShimmerThumbnail, ShimmerTitle } from 'react-shimmer-effects';
import styled from 'styled-components';

import { ThemeProp } from '../../theme/Themes';

const backgroundProps = (props: ThemeProp) => {
  return `background: ${props.theme.gradients.shimmer};
      background-size: 1000px 100%;`;
};

export interface ShimmerProps {
  $width?: string;
  $height?: string;
  $marginTop?: string;
  $marginRight?: string;
  $marginLeft?: string;
  $marginBottom?: string;
  $borderRadius?: string;
  $flex?: string;
  $onlyMobile?: boolean;
}

export const ShimmerImage = styled(ShimmerThumbnail).attrs(() => {
  // fix console warnings
  return {
    height: 0,
    width: 0,
  };
})<ShimmerProps>`
  && {
    display: block;
    &.shimmer {
      ${(props: ThemeProp) => backgroundProps(props)}
    }
    &.shimmer-thumbnail {
      min-width: unset;
      margin-bottom: ${(props: ShimmerProps) => props.$marginBottom || '0px'} !important;
      margin-left: ${(props: ShimmerProps) => props.$marginLeft || '0px'} !important;
      margin-right: ${(props: ShimmerProps) => props.$marginRight || '0px'} !important;

      width: ${(props: ShimmerProps) => props.$width || '100%'};
      height: ${(props: ShimmerProps) => props.$height || '100%'};
    }
    border-radius: ${(props: ShimmerProps) => props.$borderRadius || '0.25rem'};
  }

  @media (min-width: ${(props: ThemeProp) => props.theme.breakpoints.minMobile}) {
    ${(props: ShimmerProps) => props.$onlyMobile && 'display: none;'};
  }
`;

export const ShimmerText = styled(ShimmerTitle).attrs(() => {
  return { line: 1 };
})<ShimmerProps>`
  && {
    ${(props: ShimmerProps) => props.$flex && `flex: ${props.$flex};`}
    & .shimmer {
      ${(props: ThemeProp) => backgroundProps(props)};
      align-self: center;
    }
    &.shimmer-title {
      margin-bottom: ${(props: ShimmerProps) => props.$marginBottom || '0px'} !important;
      margin-right: ${(props: ShimmerProps) => props.$marginRight || '0px'} !important;
      margin-left: ${(props: ShimmerProps) => props.$marginLeft || '0px'} !important;
    }
    & .shimmer-title-line {
      margin-top: ${(props: ShimmerProps) => props.$marginTop || '0'} !important;
      height: ${(props: ShimmerProps) => props.$height || '1rem'};
      border-radius: ${(props: ShimmerProps) => props.$borderRadius || '0.5rem'};
      &:first-child {
        width: ${(props: ShimmerProps) => props.$width || '100%'} !important;
      }
    }
  }

  @media (min-width: ${(props: ThemeProp) => props.theme.breakpoints.minMobile}) {
    ${(props: ShimmerProps) => props.$onlyMobile && 'display: none;'};
  }
`;
